import { tv } from 'tailwind-variants';
import { endOfMonth, startOfMonth } from 'date-fns';

interface MonthGridProps {
  months: { index: number; label: string }[];
  currentMonth: Date;
  minDate: Date;
  maxDate: Date;
  onSelectMonth: (monthIndex: number) => void;
}

const classes = tv({
  slots: {
    container: 'grid grid-cols-3 gap-3 w-full',
    button: 'py-3 rounded-lg border cursor-pointer transition-colors',
    label: 'text-center headline4',
  },
  variants: {
    isActive: {
      true: {
        button: 'bg-primary text-primary-foreground border-primary',
      },
      false: {
        button: 'text-foreground hover:bg-secondary-bg',
      },
    },
    isDisabled: {
      true: {
        button: 'opacity-40 cursor-not-allowed hover:bg-transparent',
      },
      false: {},
    },
  },
  defaultVariants: {
    isActive: false,
    isDisabled: false,
  },
});

export function MonthGrid({
  months,
  currentMonth,
  minDate,
  maxDate,
  onSelectMonth,
}: MonthGridProps) {
  const year = currentMonth.getFullYear();
  const c = classes();

  return (
    <div className={c.container()}>
      {months.map(m => {
        const monthDate = new Date(year, m.index, 1);
        const isActive = currentMonth.getMonth() === m.index;
        const isDisabled =
          monthDate < startOfMonth(minDate) || monthDate > endOfMonth(maxDate);

        return (
          <button
            key={m.index}
            type="button"
            onClick={() => !isDisabled && onSelectMonth(m.index)}
            disabled={isDisabled}
            className={c.button({ isActive, isDisabled })}>
            <div className={c.label()}>{m.label}</div>
          </button>
        );
      })}
    </div>
  );
}
